<template>
  <Form ref="dictDataForm" :model="dictData" v-loading="loading" :disabled="actionType=='detail'" :rules="ruleValidate" :label-width="100" >
     <input v-model="dictData.id" type="hidden"/>

    <FormItem  :label="this.$t('system.dict-data.dictSign.label')" prop="dictSign">
      <Input v-model="dictData.dictSign" :placeholder="$t('system.dict-data.dictSign.holder')"/>
    </FormItem>

    <FormItem  :label="this.$t('system.dict-data.dictValue.label')" prop="dictValue">
      <Input v-model="dictData.dictValue" :placeholder="$t('system.dict-data.dictValue.holder')"/>
    </FormItem>

    <FormItem  :label="this.$t('system.dict-data.dictKey.label')" prop="dictKey">
      <Input v-model="dictData.dictKey" :placeholder="$t('system.dict-data.dictKey.holder')"/>
    </FormItem>

    <FormItem  :label="this.$t('system.dict-data.styleClass.label')" prop="styleClass">
      <Input v-model="dictData.styleClass" :placeholder="$t('system.dict-data.styleClass.holder')"/>
    </FormItem>

    <FormItem  :label="this.$t('system.dict-data.isDefault.label')" prop="isDefault">
      <Select v-model="dictData.isDefault" :placeholder="$t('system.dict-data.isDefault.holder')">
        <Option v-for="item in $t('system.dict-data.isDefault.dictionary')" :value="item.value" :key="item.value">{{ item.label }}</Option>
      </Select>
    </FormItem>

    <FormItem  :label="this.$t('system.dict-data.dictSort.label')" prop="dictSort">
      <InputNumber v-model="dictData.dictSort" :placeholder="$t('system.dict-data.dictSort.holder')"/>
    </FormItem>

    <FormItem  :label="this.$t('system.dict-data.status.label')" prop="status">
      <Select v-model="dictData.status" :placeholder="$t('system.dict-data.status.holder')">
        <Option v-for="item in $t('system.dict-data.status.dictionary')" :value="item.value" :key="item.value">{{ item.label }}</Option>
      </Select>
    </FormItem>

    <FormItem  :label="this.$t('system.dict-data.remark.label')" prop="remark">
      <Input v-model="dictData.remark" :placeholder="$t('system.dict-data.remark.holder')"  type="textarea" :rows="3"/>
    </FormItem>

  </Form>
</template>
<script>
import api from '@/api'

export default {
  data () {
    return {
      dictData: {
        id: null,
        dictSign: null,
        dictValue: null,
        dictKey: null,
        styleClass: null,
        isDefault: 0,
        dictSort: 0,
        status: 1,
        remark: null,
        createTime: null,
        updateTime: null,
        deleted: 0
      },
      loading: false,
      actionType:'add'
    }
  },
  methods: {
    handleSubmit(then,error){
      this.$refs['dictDataForm'].validate(valid => {
        if (valid) {
          if (this.dictData.id) {
            this.updateDictData(this.dictData).then(then).error(error)
          } else {
            this.createDictData(this.dictData).then(then).error(error)
          }
        } else {
          this.$Message.error(this.$t('errorText'))
          error()
        }
      })
    },
    handleReset(){
      this.dictData.id = ''
      this.actionType = 'add';
      this.$nextTick(()=>this.$refs['dictDataForm'].resetFields());
    },
    getDictData(id,type){
      this.loading = true;
      this.$refs['dictDataForm'].resetFields()
      api.system.DictData.detail(id).then(data => {
        this.dictData = data;
        this.loading = false;
        this.actionType = type;
      }).catch(e => this.loading = false)
    },
    createDictData(dictData){
      this.loading = true;
      return api.system.DictData.add(dictData)
          .then(response => {
            this.loading = false;
            this.$Message.success(this.$t('successText'))
            return response;
          })
          .catch(e => {
            this.loading = false;
          })
    },
    updateDictData(dictData){
      this.loading = true;
      return api.system.DictData.update(dictData)
          .then(response => {
            this.loading = false;
            this.$Message.success(this.$t('successText'))
            return response;
          })
          .catch(e => {
            this.loading = false;
          })
    }
  },
  computed: {
    ruleValidate(){
      let validate =  {
      dictSign: [{type: 'string', required: true, message: this.$t('system.dict-data.dictSign.required'),trigger: 'blur'}, {type: 'string',max: 100, message: this.$t('system.dict-data.dictSign.max'),trigger: 'blur'}],
      dictValue: [{type: 'string', required: true, message: this.$t('system.dict-data.dictValue.required'),trigger: 'blur'}, {type: 'string',max: 100, message: this.$t('system.dict-data.dictValue.max'),trigger: 'blur'}],
      dictKey: [{type: 'string', required: true, message: this.$t('system.dict-data.dictKey.required'),trigger: 'blur'}, {type: 'string',max: 100, message: this.$t('system.dict-data.dictKey.max'),trigger: 'blur'}],
      styleClass: [{type: 'string',max: 100, message: this.$t('system.dict-data.styleClass.max'),trigger: 'blur'}],
      isDefault: [{type: 'number', required: true, message: this.$t('system.dict-data.isDefault.required'),trigger: 'blur'}],
      dictSort: [{type: 'number', required: true, message: this.$t('system.dict-data.dictSort.required'),trigger: 'blur'}],
      status: [{type: 'number', required: true, message: this.$t('system.dict-data.status.required'),trigger: 'blur'}],
      remark: [{type: 'string',max: 500, message: this.$t('system.dict-data.remark.max'),trigger: 'blur'}]
      }
      if(this.actionType == 'edit'){
        this.$refs['dictDataForm'].fields.forEach(f => {
          if(f.$children[0].disabled){
            delete validate[f.prop]
          }
        })
      }else if(this.actionType == 'detail'){
        return {}
      }
      return validate;
    }
  }
}
</script>
